export default __webpack_public_path__ + "static/media/1314 utensils side.b8481e59.png";